import React from 'react';

import styled from '@emotion/styled';
import { useTranslations } from 'next-intl';

import { ConnectionIcon, UnagiIcon } from '@web/ui/icons';

import { useBlockchain } from '../hooks';

import { BackgroundStroke } from './common';
import { StakingActions } from './StakingActions';
import { ConnectedStakingBoost } from './StakingBoost/ConnectedStakingBoost';
import { ConnectedStakingConsole } from './StakingConsole/ConnectedStakingConsole';
import { StakingRewards } from './StakingRewards';
import { TerminalProvider } from './TerminalProvider';
import { TerminalTile } from './TerminalTile';

export const StakingTerminalContainer = styled.div`
  display: grid;

  position: relative;
  width: 100%;
  background: ${({ theme }) => theme.color.dark};
  border-radius: ${({ theme }) => theme.shape.corner['2500']};

  ${({ theme }) => theme.breakpoints.up('md')} {
    grid-template-columns: 1fr 1fr;
    height: 448px;
  }

  & * {
    ::selection {
      background: ${({ theme }) => theme.color.greenFixed};
      color: ${({ theme }) => theme.color.dark};
    }
  }
`;

const TerminalTiles = styled.div`
  order: -1;
  display: grid;
  gap: ${({ theme }) => theme.spacing('0500')};
  padding: ${({ theme }) => theme.spacing('1000')};

  ${({ theme }) => theme.breakpoints.up('md')} {
    order: unset;
    grid-template-columns: 1fr 1fr;
  }
`;

const RewardsAndActions = styled.div`
  display: flex;
  flex-direction: column;
  flex: 40;
  gap: ${({ theme }) => theme.spacing('0500')};
  justify-content: space-between;
`;

const RewardsTile = styled(TerminalTile)`
  width: 100%;
  box-sizing: border-box;
  flex: 2;
  justify-content: space-between;
`;

const StakingActionsTile = styled(RewardsTile)`
  justify-content: space-between;
  flex: 0;
`;

export const StakingTerminal = () => {
  const t = useTranslations();
  const blockchain = useBlockchain();

  return (
    <TerminalProvider>
      <StakingTerminalContainer>
        <BackgroundStroke />
        <ConnectedStakingConsole />

        <TerminalTiles>
          <ConnectedStakingBoost />

          <RewardsAndActions>
            <RewardsTile
              label={t('STAKING_TERMINAL_REWARDS_LABEL')}
              icon={<UnagiIcon size="1250" />}
            >
              <StakingRewards />
            </RewardsTile>
            <StakingActionsTile
              icon={<ConnectionIcon size="1250" />}
              label={t('STAKING_TERMINAL_ACTIONS_LABEL', { blockchain })}
            >
              <StakingActions />
            </StakingActionsTile>
          </RewardsAndActions>
        </TerminalTiles>
      </StakingTerminalContainer>
    </TerminalProvider>
  );
};
export { CommandButton } from './common';
export { CommandLineEntry } from './common';
